module.exports = __webpack_public_path__ + "img/partner9.1e587ced.png";